import { createApi } from "@reduxjs/toolkit/query/react"
import axiosBaseQuery from "../axiosBaseQuery"

export const forecastSegmentationApi = createApi({
    reducerPath: "forecastSegmentationApi",
    baseQuery: axiosBaseQuery(),
    endpoints: (builder) => ({
        getSegmentationData: builder.query({
            query: () => ({
                url: '/getSegmentationData',
                method: 'GET'
            })
        }),
        getSegmentationDetails: builder.mutation({
            query: (payload) => ({
                url: '/getSegementSpecficData',
                method: 'POST',
                data: payload
            })
        })
    })
})

export const {
    useGetSegmentationDataQuery,
    useGetSegmentationDetailsMutation
} = forecastSegmentationApi